<section class="patrol-list-section">
  <eventq-lined-tab label="Patrol" [count]="totalCount()" />
  <eventq-data-table
    [columns]="columns"
    [rows]="patrol.value()?.items ?? []"
    [sort]="sort()"
    [loading]="patrol.isLoading() && !patrol.hasValue()"
    [skeletonCount]="5"
    [showLabelWhenEmpty]="true"
    emptyLabel="No patrol sessions"
    (sortChange)="onSort($event)"
  />
</section>
